export const environment = {
  local: false,
  production: true,
  // Real usage but a much smaller, internal-only audience than prod, so a higher
  // sampling rate is affordable while still avoiding the previous 1.0/1.0 (every
  // session continuously CPU-profiled).
  sentry: {
    enabled: false,
    tracesSampleRate: 0.3,
    profilesSampleRate: 0.5,
    replaysSessionSampleRate: 0.2,
    replaysOnErrorSampleRate: 1,
  },
  parseAPPID: '730B65L1axRHrhQE2eP8mOXAMnak2Nq0hZBvX2wU',
  parseJSKey: 'waEKqKDCBMUA2tL1MS0feMax4mzJrAbwajM3f3QS',
  parseServerURL: 'https://internal.parse.prosafecon.de/parse',
  parseUserClass: {
    user: 'User',
    _user: '_User',
  },
  parseRoleClass: '_Role',
  features: {
    certificate: true,
    notes: true,
    contract: true,
    annualReport: true,
    statistics: true,
    map: true,
    protocol: true,
    legacyProtocol: false,
    library: true,
    paymentPeriod: false,
    accountingRange: true,
    templateChangeHistory: true,
    contractChangeHistory: true,
    v2Reporting: false,
    defaultReport: 'V2'
  }
};
